import React from "react";

const ThankYouPopup = ({ onClose }) => {
  return (
    <div className="flex items-center justify-center z-50">
      <div className="bg-white p-6 text-center w-96">
        <div className="text-4xl mb-4">🎉</div>
        <h2 className="text-2xl font-bold mb-2">Thank You!</h2>
        <p className="text-gray-600 mb-4">We have received your message.</p>
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ThankYouPopup;
